module.exports = __webpack_public_path__ + "img/sticky-note-to-ship-code.e65943b2.jpg";